import React from 'react';
import styled from 'styled-components';

const Msg = styled.div`
  font-size: 14px;
  line-height: 8px;
  color: ${props => props.theme.bodyColor};
`;
export default function MissingWireImageTip() {
  return <Msg>A wire can’t be featured without a primary image</Msg>;
}
